import gql from 'graphql-tag'

export const updateThemeVote = gql `
  mutation updateThemeVote($themeId: String!, $systemType:String!,$type: String!,$patientId: ID!,$commentId:String) {
    updateThemeVote(themeId: $themeId, systemType: $systemType, type: $type,patientId:$patientId,commentId:$commentId)
  }
`

export const insertThemeComment = gql `
  mutation insertThemeComment($activityId: String!, $systemType:String!,$content: String!,$patientId: ID!) {
    insertThemeComment(activityId: $activityId, systemType: $systemType, content: $content,patientId:$patientId)
  }
`

export const clickQuestionButton = gql `
  mutation clickQuestionButton($activityId: String!, $systemType:String!,$themeId: String!,$patientId: ID!) {
    clickQuestionButton(activityId: $activityId, systemType: $systemType, themeId: $themeId,patientId:$patientId)
  }
`
export const playVideoCount = gql `
  mutation playVideoCount($activityId: String!, $systemType:String!,$themeId: String!,$patientId: ID!) {
    playVideoCount(activityId: $activityId, systemType: $systemType, themeId: $themeId,patientId:$patientId)
  }
`



// WEBPACK FOOTER //
// ./src/modules/theme/actions/mutation.js